import { gql } from '@apollo/client';

export const DOCUMENT_EXTRACTION_TASKS_BY_DOCUMENT_IDS = gql`
  query DocumentExtractionTasksByDocumentIds($documentIds: [ID!]!) {
    documentExtractionTasksByDocumentIds(documentIds: $documentIds) {
      id
      Text
      Properties
      Assignee
      Dependents
      Status
      documentId
      UpdatedBy
      createdAt
      updatedAt
      document {
        id
        name # Include any document fields you might need
      }
    }
  }
`;
